import { render, staticRenderFns } from "./SenderNoticeForm.vue?vue&type=template&id=39db0216&scoped=true&"
import script from "./SenderNoticeForm.vue?vue&type=script&lang=js&"
export * from "./SenderNoticeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39db0216",
  null
  
)

export default component.exports